module.exports = __webpack_public_path__ + "fonts/GothamSSm-BoldItalic.6b22a3c8.ttf";